/**
 * Campo de texto de la librería de UI (Tailwind, estilos del proyecto).
 *
 * Presentacional: reenvía la `ref` y todas las props nativas de `<input>`
 * (incluido `aria-invalid`, `aria-describedby`, etc.) para que la pantalla
 * componga su accesibilidad. No etiqueta por sí mismo: el `<label htmlFor>` lo
 * pone quien lo usa (las pantallas), igual que en el login existente.
 */
import { forwardRef, type InputHTMLAttributes } from "react";

import { cn } from "./cn";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

const BASE =
  "block w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 placeholder:text-slate-400 focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand disabled:cursor-not-allowed disabled:opacity-60 aria-[invalid=true]:border-red-500 aria-[invalid=true]:focus:ring-red-500";

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, type = "text", ...props },
  ref,
) {
  return <input ref={ref} type={type} className={cn(BASE, className)} {...props} />;
});
